// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__A05dX9s+","error":"Captcha_error__Xt8j53St"};